import {
  Checkbox as MuiCheckbox,
  CheckboxProps,
  FormControlLabel,
  Box,
  Typography
} from '@mui/material';
import { forwardRef } from 'react';
import Util from '../../../../../misc/util';
import { CheckedIcon } from './icons/checked';
import { ColorEnum, Icon } from './icons/icon';
import { IndeterminateIcon } from './icons/indeterminate';

type PlainProps = Omit<
  CheckboxProps,
  'size' | 'icon' | 'checkedIcon' | 'indeterminateIcon' | 'disableRipple' | 'color'
> & { color?: ColorEnum } & { errors?: string[] };

const PlainCheckbox = forwardRef<HTMLButtonElement, PlainProps>(({ color, ...rest }, ref) => {
  return (
    <MuiCheckbox
      {...rest}
      ref={ref}
      icon={<Icon color={color} />}
      checkedIcon={<CheckedIcon color={color} />}
      indeterminateIcon={<IndeterminateIcon color={color} />}
      disableRipple={true}
      sx={Util.merge(
        {
          padding: '4px',
          '&.Mui-disabled > span': {
            borderColor: 'grey.100'
          },
          '&.Mui-disabled.Mui-checked > span': {
            backgroundImage:
              'url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4LjUzIiBoZWlnaHQ9IjUuODExIiB2aWV3Qm94PSIwIDAgOC41MyA1LjgxMSI+CiAgPHBhdGggaWQ9IlBmYWRfNDU0IiBkYXRhLW5hbWU9IlBmYWQgNDU0IiBkPSJNMTUuMiwxMC4xMTNsLTQsNEw4LjgsMTEuNzE0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNy43MzUgLTkuMDUyKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjQ0ZEOEU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPg==")'
          }
        },
        rest.sx
      )}
    />
  );
});

type Props = PlainProps & { label?: string };

export const Checkbox = forwardRef<HTMLButtonElement, Props>(({ errors, label, ...props }, ref) => {
  return (
    <Box sx={{ position: 'relative' }}>
      <FormControlLabel
        control={<PlainCheckbox ref={ref} {...props} />}
        label={label}
        sx={(theme) => ({
          '&.Mui-disabled > .MuiFormControlLabel-label': {
            color: theme.palette.grey['100']
          }
        })}
      />
      {errors && errors.length > 0 && (
        <Box
          sx={{
            position: 'absolute',
            top: '90%',
            left: '42px',
            marginTop: '0px'
          }}
        >
          {errors.map((error, index) => (
            <Typography key={index} color="error.main" fontSize={12}>
              {error}
            </Typography>
          ))}
        </Box>
      )}
    </Box>
  );
});
